import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { IncomingMessage, MessageStatus, MessagingServiceService } from 'src/app/services/messaging-service.service';



@Component({
  selector: 'app-table-input',
  templateUrl: './table-input.component.html',
  styleUrls: ['./table-input.component.css'],
})
export class TableInputComponent implements OnInit {
  @ViewChild('paginator', { static: true }) paginator!: MatPaginator;
  selection = new SelectionModel<IncomingMessage>(true, []);
  @ViewChild(MatSort)
  sort!: MatSort;

  displayedColumns: string[] = [];
  dataSource: any;
  constructor(
    private messagingService: MessagingServiceService,
    private router: Router
  ) {}


  ngOnInit(): void {
    this.displayedColumns = ['senderName', 'messageText', 'sendDateTime', 'status'];
    this.messagingService.getIncomingMessages().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.sort.sort(<MatSortable>{
        id: 'sendDateTime',
        start: 'desc',
      });
      this.dataSource.sort = this.sort;
    });
  }

  messageClicked(row: IncomingMessage) {
    if (row.status != MessageStatus.Read) {
      this.messagingService.markMessageAsRead(row.id).subscribe((data) => {});
    }
    this.router.navigate(['/show-messages', row.messageText]);
  }
}

